const adjectives: string[] = [
  "abandoned",
  "aching",
  "advanced",
  "ample",
  "artistic",
  "back",
  "best",
  "bold",
  "brief",
  "clear",
  "cold",
  "complicated",
  "cooked",
  "crazy",
  "crushing",
  "damp",
  "dear",
  "definite",
  "dependable",
  "diligent",
  "drab",
  "earnest",
  "elderly",
  "enchanted",
  "essential",
  "excellent",
  "extraneous",
  "fixed",
  "flowery",
  "formal",
  "fresh",
  "frosty",
  "giving",
  "glossy",
  "healthy",
  "helpful",
  "impressionable",
  "kind",
  "large",
  "left",
  "long",
  "loyal",
  "mealy",
  "memorable",
  "monthly",
  "new",
  "notable",
  "only",
  "ordinary",
  "passionate",
  "perfect",
  "pertinent",
  "proper",
  "puzzled",
  "reflecting",
  "respectful",
  "roasted",
  "scholarly",
  "shiny",
  "slight",
  "sparkling",
  "spotless",
  "stupendous",
  "sunny",
  "tart",
  "terrific",
  "timely",
  "unique",
  "upbeat",
  "vacant",
  "virtual",
  "warm",
  "weary",
  "whispered",
  "worthwhile",
  "yellow",
];

const nouns: string[] = [
  "account",
  "acknowledgment",
  "address",
  "advertising",
  "airplane",
  "animal",
  "appointment",
  "arrival",
  "artist",
  "attachment",
  "attitude",
  "availability",
  "backpack",
  "bag",
  "balance",
  "bass",
  "bean",
  "beauty",
  "bibliography",
  "bill",
  "bite",
  "blossom",
  "boat",
  "book",
  "box",
  "boy",
  "bread",
  "bridge",
  "broccoli",
  "building",
  "butter",
  "button",
  "cabbage",
  "cake",
  "camera",
  "camp",
  "candle",
  "candy",
  "canvas",
  "car",
  "card",
  "carrot",
  "cart",
  "case",
  "cat",
  "chain",
  "chair",
  "chalk",
  "chance",
  "change",
  "channel",
  "character",
  "charge",
  "charm",
  "chart",
  "check",
  "cheek",
  "cheese",
  "chef",
  "cherry",
  "chicken",
  "child",
  "church",
  "circle",
  "class",
  "clay",
  "click",
  "clock",
  "cloth",
  "cloud",
  "clove",
  "club",
  "coach",
  "coal",
  "coast",
  "coat",
  "cod",
  "coffee",
  "collar",
  "color",
  "comb",
  "comfort",
  "comic",
  "committee",
  "community",
  "company",
  "comparison",
  "competition",
  "condition",
  "connection",
  "control",
  "cook",
  "copper",
  "copy",
  "corn",
  "cough",
  "country",
  "cover",
  "crate",
  "crayon",
  "cream",
  "creator",
  "crew",
  "crown",
  "current",
  "curtain",
  "curve",
  "cushion",
  "dad",
  "daughter",
  "day",
  "death",
  "debt",
  "decision",
  "deer",
  "degree",
  "design",
  "desire",
  "desk",
  "detail",
  "development",
  "digestion",
  "dime",
  "dinner",
  "direction",
  "dirt",
  "discovery",
  "discussion",
  "disease",
  "disgust",
  "distance",
  "distribution",
  "division",
  "doctor",
  "dog",
  "door",
  "drain",
  "drawer",
  "dress",
  "drink",
  "driving",
  "dust",
  "ear",
  "earth",
  "edge",
  "education",
  "effect",
  "egg",
  "end",
  "energy",
  "engine",
  "error",
  "event",
  "example",
  "exchange",
  "existence",
  "expansion",
  "experience",
  "expert",
  "eye",
  "face",
  "fact",
  "fall",
  "family",
  "farm",
  "father",
  "fear",
  "feeling",
  "field",
  "finger",
  "fire",
  "fish",
  "flag",
  "flight",
  "floor",
  "flower",
  "fold",
  "food",
  "football",
  "force",
  "form",
  "frame",
  "friend",
  "frog",
  "fruit",
  "fuel",
  "furniture",
  "game",
  "garden",
  "gate",
  "girl",
  "glass",
  "glove",
  "goat",
  "gold",
  "government",
  "grade",
  "grain",
  "grass",
  "green",
  "grip",
  "group",
  "growth",
  "guide",
  "guitar",
  "hair",
  "hall",
  "hand",
  "harbor",
  "harmony",
  "hat",
  "head",
  "health",
  "heart",
  "heat",
  "hill",
  "history",
  "hobbies",
  "hole",
  "hope",
  "horn",
  "horse",
  "hospital",
  "hour",
  "house",
  "humor",
  "idea",
  "impulse",
  "income",
  "increase",
  "industry",
  "ink",
  "insect",
  "instrument",
  "insurance",
  "interest",
  "invention",
  "iron",
  "island",
  "jelly",
  "jet",
  "jewel",
  "join",
  "judge",
  "juice",
  "jump",
  "kettle",
  "key",
  "kick",
  "kiss",
  "kitten",
  "knee",
  "knife",
  "knowledge",
  "land",
  "language",
  "laugh",
  "law",
  "lead",
  "learning",
  "leather",
  "leg",
  "lettuce",
  "level",
  "library",
  "lift",
  "light",
  "limit",
  "line",
  "linen",
  "lip",
  "liquid",
  "list",
  "look",
  "loss",
  "love",
  "lunch",
  "machine",
  "man",
  "manager",
  "map",
  "marble",
  "mark",
  "market",
  "mass",
  "match",
  "meal",
  "measure",
  "meat",
  "meeting",
  "memory",
  "metal",
  "middle",
  "milk",
  "mind",
  "mine",
  "minute",
  "mist",
  "mitten",
  "mom",
  "money",
  "monkey",
  "month",
  "moon",
  "morning",
  "mother",
  "motion",
  "mountain",
  "mouth",
  "muscle",
  "music",
  "nail",
  "name",
  "nation",
  "neck",
  "need",
  "news",
  "night",
  "noise",
  "note",
  "number",
  "nut",
  "observation",
  "offer",
  "oil",
  "operation",
  "opinion",
  "orange",
  "order",
  "organization",
  "ornament",
  "oven",
  "page",
  "pail",
  "pain",
  "paint",
  "pan",
  "pancake",
  "paper",
  "parcel",
  "parent",
  "part",
  "passenger",
  "paste",
  "payment",
  "peace",
  "pear",
  "pen",
  "pencil",
  "person",
  "pest",
  "pet",
  "picture",
  "pie",
  "pin",
  "pipe",
  "pizza",
  "place",
  "plane",
  "plant",
  "plastic",
  "plate",
  "play",
  "pleasure",
  "plot",
  "plough",
  "pocket",
  "point",
  "poison",
  "police",
  "pollution",
  "popcorn",
  "porter",
  "position",
  "pot",
  "potato",
  "powder",
  "power",
  "price",
  "print",
  "process",
  "produce",
  "product",
  "profit",
  "property",
  "prose",
  "protest",
  "pull",
  "pump",
  "punishment",
  "purpose",
  "push",
  "quarter",
  "question",
  "quiet",
  "quill",
  "quilt",
  "quince",
  "rabbit",
  "rail",
  "rain",
  "range",
  "rat",
  "rate",
  "ray",
  "reaction",
  "reading",
  "reason",
  "record",
  "regret",
  "relation",
  "religion",
  "representative",
  "request",
  "respect",
  "rest",
  "reward",
  "rhythm",
  "rice",
  "river",
  "road",
  "roll",
  "room",
  "root",
  "rose",
  "route",
  "rub",
  "rule",
  "run",
  "sack",
  "sail",
  "salt",
  "sand",
  "scale",
  "scarecrow",
  "scarf",
  "scene",
  "scent",
  "school",
  "science",
  "scissors",
  "screw",
  "sea",
  "seat",
  "secretary",
  "seed",
  "selection",
  "self",
  "sense",
  "servant",
  "shade",
  "shake",
  "shame",
  "shape",
  "sheep",
  "sheet",
  "shelf",
  "ship",
  "shirt",
  "shock",
  "shoe",
  "shop",
  "show",
  "side",
  "sign",
  "silk",
  "sink",
  "sister",
  "size",
  "sky",
  "sleep",
  "smash",
  "smell",
  "smile",
  "smoke",
  "snail",
  "snake",
  "sneeze",
  "snow",
  "soap",
  "society",
  "sock",
  "soda",
  "sofa",
  "son",
  "song",
  "sort",
  "sound",
  "soup",
  "space",
  "spark",
  "speed",
  "sponge",
  "spoon",
  "spray",
  "spring",
  "spy",
  "square",
  "stamp",
  "star",
  "start",
  "statement",
  "station",
  "steam",
  "steel",
  "stem",
  "step",
  "stew",
  "stick",
  "stitch",
  "stocking",
  "stomach",
  "stone",
  "stop",
  "store",
  "story",
  "stove",
  "stranger",
  "straw",
  "stream",
  "street",
  "stretch",
  "string",
  "structure",
  "substance",
  "sugar",
  "suggestion",
  "suit",
  "summer",
  "sun",
  "support",
  "surprise",
  "sweater",
  "swim",
  "system",
  "table",
  "tail",
  "talk",
  "tank",
  "taste",
  "tax",
  "tea",
  "teaching",
  "team",
  "tendency",
  "test",
  "texture",
  "theory",
  "thing",
  "thought",
  "thread",
  "throat",
  "thumb",
  "thunder",
  "ticket",
  "time",
  "tin",
  "title",
  "toad",
  "toe",
  "tooth",
  "toothpaste",
  "touch",
  "town",
  "toy",
  "trade",
  "train",
  "transport",
  "tray",
  "treatment",
  "tree",
  "trick",
  "trip",
  "trouble",
  "trousers",
  "truck",
  "tub",
  "turkey",
  "turn",
  "twist",
  "umbrella",
  "uncle",
  "underwear",
  "unit",
  "use",
  "vacation",
  "value",
  "van",
  "vase",
  "vegetable",
  "veil",
  "vein",
  "verse",
  "vessel",
  "view",
  "visitor",
  "voice",
  "volcano",
  "walk",
  "wall",
  "war",
  "wash",
  "waste",
  "watch",
  "water",
  "wave",
  "wax",
  "way",
  "wealth",
  "weather",
  "week",
  "weight",
  "wheel",
  "whip",
  "whistle",
  "window",
  "wine",
  "wing",
  "winter",
  "wire",
  "wish",
  "woman",
  "wood",
  "wool",
  "word",
  "work",
  "worm",
  "wound",
  "wrist",
  "writer",
  "yard",
  "yoke",
  "zebra",
  "zinc",
  "zipper",
  "zone",
];

export function randomName(): string {
  const adjective: string =
    adjectives[Math.floor(Math.random() * adjectives.length)];
  const noun: string = nouns[Math.floor(Math.random() * nouns.length)];
  const number: number = Math.floor(Math.random() * 100) + 1;
  return `${adjective}-${noun}-${number}`;
}
